export default userCommunityService

/** @ngInject */
function userCommunityService(ApiService, Community, $q, ErrorCatcher) {
    let userCommunity = {}

    const fetchCommunityInfo = () => {
        return ApiService.fetchUserInfo()
        .then((userInfoResult) => {
            return $q.all({
                info: Community.fetchUserInfo({ uid: userInfoResult.forum_uid }).$promise,
                chats: Community.getChats().$promise,
                notifications: Community.getNotifications().$promise,
            })
            .then((userCommunityResult) => {
                userCommunity = userCommunityResult
            })
        })
        .catch((error) => {
            userCommunity = {}
            return ErrorCatcher.catchErrorWithoutRedirect(error)
        })
    }

    const getUserCommunityInfo = () => {
        return userCommunity.info
    }

    const getChatsCount = () => {
        const unreadChats = userCommunity.chats != null ? userCommunity.chats.rooms.filter((room) => room.unread) : undefined
        return unreadChats ? unreadChats.length : 0
    }

    const getNotificationsCount = () => {
        const unreadNotifications = userCommunity.notifications != null ? userCommunity.notifications.notifications.filter((notification) => !notification.read) : undefined
        return unreadNotifications ? unreadNotifications.length : 0
    }

    return {
        fetchCommunityInfo,
        getUserCommunityInfo,
        getChatsCount,
        getNotificationsCount,
    }
}



// WEBPACK FOOTER //
// ./src/services/community/userCommunity.js